import { gql } from '@apollo/client';

export * from './beneficiaryCreate.mutation.generated';

export const BENEFICIARY_CREATE = gql`
  mutation beneficiaryCreate($escrowId: ID!, $beneficiaryParams: EscrowPartyParams!) {
    beneficiaryCreate(input: { escrowId: $escrowId, beneficiaryParams: $beneficiaryParams }) {
      success
      errors
      beneficiary {
        escrow {
          id
          beneficiaryConfigured
          beneficiary {
            id
            companyName
            companyWebsite
            companyRegistrationNumber
            city
            region
            postalCode
            country
            street
            streetNumber
          }
          ... on SoftwareEscrow {
            policy {
              createBeneficiary
            }
          }
        }
      }
    }
  }
`;
